import { createApp } from 'vue'
import App from './App.vue'
// import "bootstrap/dist/css/bootstrap.min.css"
// import "bootstrap"

const dataId = document.querySelector("#placementtestapp").getAttribute('data-id');

createApp(App, {'id': parseInt(dataId) }).mount('#placementtestapp')
